import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkb702aRequest, Sgkb702aResponse, SGKB702AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb702aService {
  /** 包括契約、包括対象需給契約検索結果のSubject */
  private _incCtrSearchResult$: Subject<Sgkb702aResponse> = new Subject<Sgkb702aResponse>();

  /**
   * 包括契約、包括対象需給契約検索結果のobservable提供
   * @readonly
   * @memberof UsedSgkb702aService
   */
  get incCtrSearchChanges(): Observable<Sgkb702aResponse> {
    return this._incCtrSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB702AService} SGKB702AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @memberof UsedSgkb702aService
   */
  constructor(
    private sGKB702AService: SGKB702AService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 包括契約検索API呼び出し
   * @param {*} value
   * @return {*}  {Observable<sgkb702aResponse>}
   * @memberof UsedSgkc006aService
   */
  searchContractor(value: Sgkb702aRequest): Observable<Sgkb702aResponse> {
    // 検索条件を保存
    return this.sGKB702AService.SGKB702APost(<Sgkb702aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._incCtrSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKB702A);
          return throwError(err.message);
        })
      );
  }
}
